// src/components/FlipBrochure/FlipBrochure.jsx
import React, { useState, useEffect, useCallback } from 'react';
import './FlipBrochure.css';

const FlipBrochure = ({
  frontSrc,
  backSrc,
  frontAlt,
  backAlt,
  frontLabel = 'Outside',
  backLabel = 'Inside',
}) => {
  const [flipped, setFlipped] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, close]);

  const activeSrc = flipped ? backSrc : frontSrc;
  const activeAlt = flipped ? backAlt : frontAlt;
  const activeLabel = flipped ? backLabel : frontLabel;

  return (
    <div className="flip-brochure">
      <button
        type="button"
        className={`flip-brochure-card ${flipped ? 'is-flipped' : ''}`}
        onClick={() => setFlipped((prev) => !prev)}
        aria-label="Flip brochure"
      >
        <div className="flip-brochure-face flip-brochure-front">
          <img src={frontSrc} alt={frontAlt} />
        </div>
        <div className="flip-brochure-face flip-brochure-back">
          <img src={backSrc} alt={backAlt} />
        </div>
      </button>

      <div className="flip-brochure-controls">
        <p className="flip-brochure-hint">Tap to flip &#8226; showing: {activeLabel}</p>
        <button
          type="button"
          className="flip-brochure-enlarge"
          onClick={() => setIsOpen(true)}
        >
          Enlarge
        </button>
      </div>

      {isOpen && (
        <div className="flip-brochure-overlay" onClick={close}>
          <button type="button" className="flip-brochure-overlay-close" onClick={close} aria-label="Close">
            &times;
          </button>
          <img
            src={activeSrc}
            alt={activeAlt}
            className="flip-brochure-overlay-image"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            className="flip-brochure-overlay-flip"
            onClick={(e) => {
              e.stopPropagation();
              setFlipped((prev) => !prev);
            }}
          >
            Flip to {flipped ? frontLabel : backLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default FlipBrochure;
